export default __webpack_public_path__ + "static/media/invert-affimob.918b9c24.svg";